import React, { useContext, useEffect, useState } from 'react';
import { Button, Image, Space, Switch, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import GlobalContainer from '../../components/global-container';
import CustomModal from '../../components/modal';
import { Context } from '../../context/context';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { addMenu, disableRefetch } from '../../redux/slices/menu';
import classificationService from '../../services/classification';
import { fetchClassifications } from '../../redux/slices/classification';
import ClassificationShowModal from './classificationShowModal';

import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Classifications = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showId, setShowId] = useState(null);
  const goToShow = (row) => {
    setShowId(row.id);
  };
  const goToEdit = (row) => {
    dispatch(
      addMenu({
        url: `classification/${row.id}`,
        id: 'classification_edit',
        name: t('edit.classification'),
      })
    );
    navigate(`/classification/${row.id}`);
  };

  const columns = [
    {
      title: t('title'),
      dataIndex: 'translation',
      key: 'translation',
      render: (translation) => translation?.title,

    },
    {
      title: t('min_order'),
      dataIndex: 'min_order',
      key: 'min_order',
    },
    {
      title: t('active'),
      dataIndex: 'active',
      key: 'active',
      render: (active, row) => {
        return (
          <Switch
            key={row.id + active}
            onChange={() => {
              setIsModalVisible(true);
              setActiveId(row.id);
              setType(true);
            }}
            checked={active}
          />
        );
      },
    },
    {
      title: t('options'),
      key: 'options',
      dataIndex: 'options',
      render: (data, row) => (
        <Space>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => goToEdit(row)}
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => {
              setIsModalVisible(true);
              setId(row.id);
              setType(false);
            }}
          />
          <Button icon={<EyeOutlined />} onClick={() => goToShow(row)} />
        </Space>
      ),
    },
  ];
  const { setIsModalVisible } = useContext(Context);
  const [id, setId] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [type, setType] = useState(null);
  const [loadingBtn, setLoadingBtn] = useState(false);

  const { activeMenu } = useSelector((state) => state.menu, shallowEqual);
  const { classifications, meta, loading } = useSelector(
    (state) => state.classification,
    shallowEqual
  );
  const classificationDelete = () => {
    setLoadingBtn(true);
    classificationService
      .delete(id)
      .then(() => {
        dispatch(fetchClassifications());
        toast.success(t('successfully.deleted'), {autoClose: 10000});
      })
      .finally(() => {
        setIsModalVisible(false);
        setLoadingBtn(false);
      });
  };

  const handleActive = () => {
    setLoadingBtn(true);
    classificationService
      .setActive(activeId)
      .then(() => {
        setIsModalVisible(false);
        dispatch(fetchClassifications());
        toast.success(t('successfully.updated'), {autoClose: 10000});
      })
      .finally(() => setLoadingBtn(false));
  };

  useEffect(() => {
    if (activeMenu.refetch) {
      dispatch(fetchClassifications());
      dispatch(disableRefetch(activeMenu));
    }
  }, [activeMenu.refetch]);

  const onChangePagination = (pageNumber) => {
    const { pageSize, current } = pageNumber;
    dispatch(fetchClassifications({ perPage: pageSize, page: current }));
  };

  return (
    <GlobalContainer
      headerTitle={t('classifications')}
      navLInkTo={'/classification/add'}
      buttonTitle={t('add.classification')}
    >
      <Table
        columns={columns}
        dataSource={classifications}
        pagination={{
          pageSize: meta.per_page,
          page: meta.current_page,
          total: meta.total,
        }}
        rowKey={(record) => record.id}
        loading={loading}
        onChange={onChangePagination}
      />
      <CustomModal
        click={type ? handleActive : classificationDelete}
        text={type ? t('set.active.classification') : t('delete.classification')}
        loading={loadingBtn}
      />
      {showId && (
        <ClassificationShowModal
          id={showId}
          handleCancel={() => setShowId(null)}
        />
      )}
    </GlobalContainer>
  );
};

export default Classifications;
